import { IoIosNotifications } from "react-icons/io";
import { Search } from "./Search";
import { Link, useLocation } from "react-router-dom";
import userImage from '../assets/images/Image.png'
import { FaCircleCheck } from "react-icons/fa6";
import {FaBars, FaTimes} from 'react-icons/fa'
import { SidebarData } from "./sidebar/SideBar";
import { useEffect, useRef, useState } from "react";
import Warning from '../assets/images/WarningOctagon.png'
import { MdOutlineLogout } from "react-icons/md";
import { fetchUsers } from "../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotification } from "../redux/slices/notificationSlice";

const NavBar = () => {
  const [nav, setNav] = useState(false)
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [imageFile, setImageFile] = useState('')

  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth);
  const notification = useSelector((state) => state?.notification);
  const notificationData = notification?.notification?.data || 0;

  useEffect(() =>{
    dispatch(fetchUsers())
  }, [dispatch]);

   useEffect(() => {
    dispatch(fetchNotification({ pageSize: 10, pageNumber: 1 }));
  }, [dispatch]);

  const userProfile = user?.user?.data?.profile;

  useEffect(() => {
    if (userProfile?.profileImage?.length > 0) {
      setImageFile(userProfile?.profileImage);
    }
  }, [userProfile]);

  const pathMatchRoute = (route) => {
      if (route === location.pathname) {
          return true
      }
  }

  const handleClick = () => {
    setOpen(prev => !prev);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setNav(false);
      }
    };

    if (nav) {
      document.body.style.overflow = "hidden";
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.body.style.overflow = "auto";
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [nav]);
  
  return (
    <div className="fixed top-0 right-0 left-0 lg:left-64 bg-white z-[80]">
      <div className="px-6 sm:px-8 py-3 border-b border-b-primaryGray">
        <div className="flex items-center justify-between">
          <button 
              onClick={() => setNav(!nav)}
              className="cursor-pointer pr-4 z-[100] text-primaryRed lg:hidden">
              {nav ? 
                <div className="grid place-items-end text-white">
                  <FaTimes size={20} className="grid place-items-end text-white" /> 
                </div> :
                <FaBars size={20} />
              }
          </button>
          {nav && (
            <ul 
              className="flex flex-col pt-20 absolute top-0 left-0 w-[300px] bg-primaryBrown h-screen z-[90]"
              ref={sidebarRef}
            >
              {
                SidebarData.map((item, index) =>(
                  <ul
                    key={index}
                  >
                  <Link
                    key={index}
                    to={item.path}
                    className="text-white"
                  >
                    <li
                      className={`${pathMatchRoute(item.path) && "bg-white border-r-[8px] rounded-tr-md rounded-br-md border-r-primaryRed font-semibold text-primaryRed"} pl-4 py-2 flex items-center gap-x-5`}
                    >
                      <span className="text-xl">{item.icon}</span>
                      <span className="ml-2 py-1 mr-6 text-md whitespace-nowrap">{item.title}</span>
                    </li>
                  </Link>
                </ul>
                ))
              }
              <div className="bg-orange mx-4 mt-6 rounded-md px-2">
                <div className="px-2 py-3 flex items-center">
                <div className="">
            {imageFile ? (
              <div className="relative">
                <img
                  src={imageFile}
                  alt="Selected"
                  className={` w-10 h-10 rounded-full object-cover`}
                />
                <FaCircleCheck className="absolute bottom-0 right-0 text-orange text-xl" />
              </div>
              ) : (
                <div className="relative">
                  <img src={userImage} alt="profile-image" className="h-10 w-10" />
                  <FaCircleCheck className="absolute bottom-0 right-0 text-orange text-xl" />
                </div>
            )}
            </div>
                  <div className="mx-3 text-sm">
                    <p className="mb-1 font-semibold">{userProfile?.userName}</p>
                    <p className="">{userProfile?.roleName}</p>
                  </div>
                  {/* logout alert dialog */}
                  <div>
                    <MdOutlineLogout className="text-primaryRed text-2xl cursor-pointer" onClick={handleClick} />
                    {open &&
                      <div className="fixed inset-0 bg-orange/20 backdrop-blur-[1px] grid place-items-center z-50">
                        <div className='bg-white rounded-2xl py-5 px-4 max-w-sm'>
                          <div className=" flex justify-center rounded-full">
                            <img src={Warning} alt="" className='bg-[#eec4c4] rounded-full' />
                          </div>
                          <div className='mt-5'>
                            <h2 className="text-2xl text-primaryRed text-center">confirm log out</h2>
                            <div>
                              <p class="text-center py-4">
                                Are you sure you want to log out? Any unsaved changes will be lost.
                              </p>
                            </div>
                            <div className='flex justify-between items-center mt-5 '>
                              <button className="text-primaryRed border-2 border-primaryRed px-6 py-2 rounded-md" onClick={handleClick}>Cancel</button>
                              <Link className="text-white border-2 border-primryRed bg-primaryRed px-6 py-2 rounded-md" to='/' onClick={handleClick} autoFocus>
                                Logout
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </ul>
          )}
          <Search />
          <div className="flex items-center justify-between gap-x-6">
          <Link to='/notification' className="relative">
              <IoIosNotifications className="h-8 w-8 text-primaryGray" />
              {notificationData.length > 0 && (
                <p className="absolute top-0 -right-0 bg-primaryRed rounded-full text-white h-4 w-4 text-center text-xs">
                  {notificationData.length}
                </p>
              )}
          </Link>
          <Link to='/settings'>
            <div className="">
            {imageFile ? (
              <div className="relative">
                <img
                  src={imageFile}
                  alt="Selected"
                  className={` w-10 h-10 rounded-full object-cover`}
                />
                <FaCircleCheck className="absolute bottom-0 right-0 text-orange text-xl" />
              </div>
              ) : (
                <div className="relative">
                  <img src={userImage} alt="profile-image" className="h-10 w-10" />
                  <FaCircleCheck className="absolute bottom-0 right-0 text-orange text-xl" />
                </div>
            )}
            </div>
          </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default NavBar;
